import i18n from '@/lang'
import { getUserLanguage } from '@/utils/auth'
i18n.locale = getUserLanguage()
// 用到的公共数据在此处维护
const commontData = {
  state: {
    keys: 'commontData',
    usertypeList: [
      { label: i18n.t('public.usertypeList.internalUsers'), value: 0 },
      { label: i18n.t('public.usertypeList.externalUsers'), value: 1 }
    ],
    downLoadStatus: [
      { label: i18n.t('statistical.hisDownloadTabel.queue'), value: 1 },
      { label: i18n.t('statistical.hisDownloadTabel.processing'), value: 2 },
      { label: i18n.t('statistical.hisDownloadTabel.compressing'), value: 3 },
      { label: i18n.t('statistical.hisDownloadTabel.completed'), value: 4 },
      { label: i18n.t('statistical.hisDownloadTabel.abnormal'), value: 5 },
      { label: i18n.t('statistical.hisDownloadTabel.noHistoricalData'), value: 6 }
    ]
  }

}
export default commontData
